var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _g2, _g3, _path12, _path13, _path14, _path15, _g4, _ellipse, _ellipse2, _ellipse3, _rect, _path16, _path17, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirst(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58301 40.2207C7.98241 39.0087 10.5788 37.5985 12.0211 37.0613L14.2741 41.046L20.2961 42.3743C19.5461 42.3743 13.1603 45.3468 10.3957 46.8017V42.3285C9.02189 41.3412 7.58301 40.2207 7.58301 40.2207Z",
    fill: "#531CB4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.377 40.2207C41.9775 39.0087 39.3812 37.5985 37.9388 37.0613L35.6859 41.046L29.2178 42.3743C29.9678 42.3743 36.7997 45.3468 39.5643 46.8017V42.3285C40.9381 41.3412 42.377 40.2207 42.377 40.2207Z",
    fill: "#531CB4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.62 39.2751L20.2964 42.3744L14.2744 41.0461L17.62 39.2751Z",
    fill: "#7266F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1174 39.2751L29.218 42.3744L35.686 41.0461L32.1174 39.2751Z",
    fill: "#7266F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7939 0.312988L31.9406 8.61451H17.6471L24.7939 0.312988Z",
    fill: "url(#paint0_linear_1565_28588)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7945 47.687L17.6478 39.3855L31.9413 39.3855L24.7945 47.687Z",
    fill: "url(#paint1_linear_1565_28588)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1565_28588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.7943 2.52661L25.6223 5.02541L28.1398 5.84722L25.6223 6.66903L24.7943 9.16783L23.9663 6.66903L21.4487 5.84722L23.9663 5.02541L24.7943 2.52661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7943 2.60168L25.5998 5.03284L25.6036 5.04416L25.6149 5.04786L28.0637 5.84722L25.6149 6.64658L25.6036 6.65028L25.5998 6.6616L24.7943 9.09276L23.9887 6.6616L23.985 6.65028L23.9736 6.64658L21.5248 5.84722L23.9736 5.04786L23.985 5.04416L23.9887 5.03284L24.7943 2.60168Z",
    stroke: "#FAFF00",
    strokeWidth: 0.0472264
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4617 35.8437L34.645 37.8361L41.7918 25.5498L45.4617 35.8437Z",
    fill: "url(#paint2_linear_1565_28588)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12618 12.1563L14.9429 10.1639L7.79613 22.4502L4.12618 12.1563Z",
    fill: "url(#paint3_linear_1565_28588)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4616 12.1567L41.7917 22.4506L34.6449 10.1643L45.4616 12.1567Z",
    fill: "url(#paint4_linear_1565_28588)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.12675 35.8433L7.79671 25.5494L14.9435 37.8357L4.12675 35.8433Z",
    fill: "url(#paint5_linear_1565_28588)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M43.188 23.7789C43.188 33.7383 35.0534 41.8135 25.017 41.8135C14.9807 41.8135 6.84609 33.7383 6.84609 23.7789C6.84609 13.8195 14.9807 5.74429 25.017 5.74429C35.0534 5.74429 43.188 13.8195 43.188 23.7789Z",
    fill: "url(#paint6_linear_1565_28588)",
    stroke: "url(#paint7_linear_1565_28588)",
    strokeWidth: 0.236132
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1565_28588)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.0171,
    cy: 23.779,
    rx: 16.0586,
    ry: 15.9389,
    fill: "url(#paint8_linear_1565_28588)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_1565_28588)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.017,
    cy: 23.7783,
    rx: 13.3822,
    ry: 13.2824,
    fill: "url(#paint9_linear_1565_28588)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1565_28588)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1149 21.5099C16.8768 20.8703 17.592 20.297 18.1645 20.6685L28.8728 27.6179C29.4646 28.002 29.1926 28.9206 28.4872 28.9206H20.3657C20.0698 28.9206 19.805 28.7366 19.7018 28.4593L17.1149 21.5099Z",
    fill: "url(#paint10_linear_1565_28588)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9173 21.5013C33.1579 20.8632 32.4464 20.287 31.8723 20.6549L21.0089 27.6157C20.4131 27.9974 20.6835 28.9206 21.3911 28.9206H29.6301C29.925 28.9206 30.189 28.7379 30.293 28.4621L32.9173 21.5013Z",
    fill: "url(#paint11_linear_1565_28588)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3828 18.9562C24.6418 18.4269 25.3962 18.4269 25.6553 18.9562L30.0788 27.9936C30.3092 28.4642 29.9665 29.0134 29.4426 29.0134H20.5955C20.0715 29.0134 19.7289 28.4642 19.9592 27.9936L24.3828 18.9562Z",
    fill: "url(#paint12_linear_1565_28588)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1565_28588",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 18,
    width: 12,
    height: 12
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3823 18.9547C24.6413 18.4254 25.3957 18.4254 25.6548 18.9547L30.0783 27.9921C30.3087 28.4627 29.9661 29.0119 29.4421 29.0119H20.595C20.071 29.0119 19.7284 28.4627 19.9588 27.9921L24.3823 18.9547Z",
    fill: "url(#paint13_linear_1565_28588)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1565_28588)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1565_28588)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.82228,
    cy: 1.58009,
    rx: 5.82228,
    ry: 1.58009,
    transform: "matrix(0.204188 0.978932 -0.979534 0.201279 28.624 19.0801)",
    fill: "#FFF5D2",
    fillOpacity: 0.8
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.0189,
    cy: 16.8248,
    rx: 1.02331,
    ry: 1.01568,
    fill: "url(#paint14_linear_1565_28588)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.933,
    cy: 19.779,
    rx: 0.837252,
    ry: 0.831011,
    fill: "url(#paint15_linear_1565_28588)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33.0628,
    cy: 19.779,
    rx: 0.837252,
    ry: 0.831011,
    fill: "url(#paint16_linear_1565_28588)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.832,
    y: 29.8142,
    width: 10.1778,
    height: 1.37753,
    rx: 0.688766,
    fill: "url(#paint17_linear_1565_28588)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8797 12.2673L18.2109 13.2669L19.2179 13.5956L18.2109 13.9243L17.8797 14.9238L17.5485 13.9243L16.5415 13.5956L17.5485 13.2669L17.8797 12.2673Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8647 7.84009L14.6375 10.1723L16.9872 10.9393L14.6375 11.7063L13.8647 14.0386L13.0919 11.7063L10.7422 10.9393L13.0919 10.1723L13.8647 7.84009Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1565_28588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.7061 35.391L14.2746 41.0458C23.8652 35.9542 33.0097 39.7175 35.6862 41.0458L39.2548 35.391C38.2343 34.2211 33.9579 31.8552 25.016 31.7512C16.0741 31.6472 11.7502 34.1344 10.7061 35.391Z",
    fill: "url(#paint18_linear_1565_28588)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1565_28588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2475 36.6628L20.447 34.2908V34.2707H19.0597V33.9151H20.8763V34.2827L19.6809 36.6628H19.2475ZM21.5092 36.6628L22.7087 34.2908V34.2707H21.3214V33.9151H23.138V34.2827L21.9426 36.6628H21.5092ZM25.1407 34.6369C25.1264 34.5099 25.0674 34.4115 24.9637 34.3418C24.8599 34.2711 24.7293 34.2358 24.5719 34.2358C24.4592 34.2358 24.3617 34.2537 24.2794 34.2894C24.1971 34.3243 24.1332 34.3726 24.0875 34.4343C24.0428 34.4952 24.0205 34.5645 24.0205 34.6423C24.0205 34.7076 24.0357 34.7639 24.0661 34.8114C24.0974 34.8588 24.1381 34.8986 24.1882 34.9308C24.2392 34.9621 24.2937 34.9884 24.3519 35.0099C24.41 35.0305 24.4659 35.0475 24.5196 35.0609L24.7879 35.1307C24.8755 35.1521 24.9654 35.1812 25.0576 35.2179C25.1497 35.2545 25.2351 35.3028 25.3138 35.3628C25.3925 35.4227 25.456 35.4969 25.5043 35.5855C25.5535 35.674 25.5781 35.78 25.5781 35.9035C25.5781 36.0591 25.5379 36.1973 25.4574 36.318C25.3778 36.4388 25.2619 36.534 25.1099 36.6038C24.9587 36.6736 24.7758 36.7085 24.5612 36.7085C24.3554 36.7085 24.1774 36.6758 24.0272 36.6105C23.8769 36.5452 23.7593 36.4526 23.6743 36.3328C23.5893 36.212 23.5424 36.0689 23.5334 35.9035H23.9494C23.9574 36.0027 23.9896 36.0855 24.046 36.1517C24.1032 36.217 24.1761 36.2657 24.2646 36.2979C24.3541 36.3292 24.452 36.3449 24.5585 36.3449C24.6756 36.3449 24.7798 36.3265 24.8711 36.2899C24.9632 36.2523 25.0357 36.2004 25.0884 36.1342C25.1412 36.0671 25.1676 35.9889 25.1676 35.8994C25.1676 35.818 25.1443 35.7514 25.0978 35.6995C25.0522 35.6477 24.99 35.6047 24.9113 35.5707C24.8335 35.5367 24.7454 35.5068 24.647 35.4808L24.3223 35.3923C24.1023 35.3324 23.9279 35.2443 23.7991 35.128C23.6712 35.0117 23.6072 34.8579 23.6072 34.6665C23.6072 34.5081 23.6502 34.3699 23.736 34.2519C23.8219 34.1338 23.9382 34.0421 24.0849 33.9768C24.2316 33.9106 24.397 33.8776 24.5813 33.8776C24.7673 33.8776 24.9315 33.9102 25.0737 33.9755C25.2168 34.0408 25.3295 34.1307 25.4118 34.2452C25.4941 34.3588 25.537 34.4894 25.5406 34.6369H25.1407ZM28.4604 35.289C28.4604 35.5824 28.4067 35.8346 28.2994 36.0457C28.192 36.2559 28.0449 36.4178 27.8579 36.5314C27.6719 36.6441 27.4604 36.7004 27.2233 36.7004C26.9854 36.7004 26.773 36.6441 26.5861 36.5314C26.4 36.4178 26.2533 36.2554 26.146 36.0443C26.0387 35.8332 25.985 35.5815 25.985 35.289C25.985 34.9956 26.0387 34.7438 26.146 34.5336C26.2533 34.3225 26.4 34.1606 26.5861 34.0479C26.773 33.9344 26.9854 33.8776 27.2233 33.8776C27.4604 33.8776 27.6719 33.9344 27.8579 34.0479C28.0449 34.1606 28.192 34.3225 28.2994 34.5336C28.4067 34.7438 28.4604 34.9956 28.4604 35.289ZM28.0498 35.289C28.0498 35.0654 28.0136 34.8771 27.9411 34.7241C27.8696 34.5703 27.7712 34.454 27.646 34.3753C27.5216 34.2957 27.3808 34.2559 27.2233 34.2559C27.065 34.2559 26.9237 34.2957 26.7994 34.3753C26.675 34.454 26.5767 34.5703 26.5042 34.7241C26.4327 34.8771 26.3969 35.0654 26.3969 35.289C26.3969 35.5126 26.4327 35.7013 26.5042 35.8552C26.5767 36.0081 26.675 36.1244 26.7994 36.204C26.9237 36.2827 27.065 36.3221 27.2233 36.3221C27.3808 36.3221 27.5216 36.2827 27.646 36.204C27.7712 36.1244 27.8696 36.0081 27.9411 35.8552C28.0136 35.7013 28.0498 35.5126 28.0498 35.289ZM28.9772 36.6628V33.9151H29.3918V36.306H30.6369V36.6628H28.9772Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1565_28588",
    x: 20.7403,
    y: 1.81821,
    width: 8.10771,
    height: 8.05791,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.354198,
    result: "effect1_foregroundBlur_1565_28588"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1565_28588",
    x: 8.9585,
    y: 7.36782,
    width: 32.1172,
    height: 32.3502,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.472264
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.236132
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.616667 0 0 0 0 0.407 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1565_28588"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_1565_28588",
    x: 11.6348,
    y: 10.0236,
    width: 26.7642,
    height: 27.5095,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.472264
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.472264
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.7 0 0 0 0 0.465967 0 0 0 0 0.0116667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1565_28588"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.472264
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.236132
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.72 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1565_28588",
    result: "effect2_innerShadow_1565_28588"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1565_28588",
    x: 15.6234,
    y: 15.8091,
    width: 18.7487,
    height: 16.3271,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.472264
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.236132
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.358333 0 0 0 0 0.1935 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1565_28588"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1565_28588",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1565_28588",
    x: 24.8967,
    y: 17.9724,
    width: 6.73691,
    height: 14.2508,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.708397,
    result: "effect1_foregroundBlur_1565_28588"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1565_28588",
    x: 5.98341,
    y: 29.3867,
    width: 37.9941,
    height: 18.7429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.36132
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.36132
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1565_28588"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1565_28588",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1565_28588",
    x: 19.0596,
    y: 33.8774,
    width: 11.5771,
    height: 3.06719,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.236132
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.221676 0 0 0 0 0.154219 0 0 0 0 0.5875 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1565_28588"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1565_28588",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1565_28588",
    x1: 21.823,
    y1: 3.6336,
    x2: 27.7647,
    y2: 3.6336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484631,
    stopColor: "#FFE590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1565_28588",
    x1: 27.7654,
    y1: 44.3664,
    x2: 21.8237,
    y2: 44.3664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484631,
    stopColor: "#FFE590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1565_28588",
    x1: 44.0498,
    y1: 31.6298,
    x2: 41.1122,
    y2: 36.7561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484631,
    stopColor: "#FFE590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1565_28588",
    x1: 5.53809,
    y1: 16.3702,
    x2: 8.47571,
    y2: 11.2439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484631,
    stopColor: "#FFE590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1565_28588",
    x1: 41.0789,
    y1: 11.2634,
    x2: 44.0165,
    y2: 16.3897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484631,
    stopColor: "#FFE590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1565_28588",
    x1: 8.50951,
    y1: 36.7366,
    x2: 5.57188,
    y2: 31.6103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.484631,
    stopColor: "#FFE590"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#FFC700"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1565_28588",
    x1: 13.2933,
    y1: 10.2807,
    x2: 37.4765,
    y2: 37.4569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFECA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.237301,
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9900"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1565_28588",
    x1: 25.017,
    y1: 5.62622,
    x2: 25.017,
    y2: 41.9315,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1565_28588",
    x1: 14.7575,
    y1: 11.6034,
    x2: 35.095,
    y2: 36.3255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D58500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1565_28588",
    x1: 16.1611,
    y1: 12.8398,
    x2: 27.0454,
    y2: 37.1218,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB13C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#B45F1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#743110"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1565_28588",
    x1: 17.2478,
    y1: 22.1801,
    x2: 22.6511,
    y2: 26.1393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE176"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1565_28588",
    x1: 32.2253,
    y1: 21.0366,
    x2: 28.971,
    y2: 26.9383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE483"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F29100"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1565_28588",
    x1: 22.1752,
    y1: 23.5025,
    x2: 27.9441,
    y2: 23.5025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49738,
    stopColor: "#FCE77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49738,
    stopColor: "#FFCC1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1565_28588",
    x1: 22.1747,
    y1: 23.5011,
    x2: 27.9436,
    y2: 23.5011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49738,
    stopColor: "#FCE77B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49738,
    stopColor: "#FFCC1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1565_28588",
    x1: 25.0189,
    y1: 15.8091,
    x2: 25.0189,
    y2: 17.8404,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF971D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1565_28588",
    x1: 16.933,
    y1: 18.948,
    x2: 16.933,
    y2: 20.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF971D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1565_28588",
    x1: 33.0628,
    y1: 18.948,
    x2: 33.0628,
    y2: 20.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF971D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1565_28588",
    x1: 19.9477,
    y1: 30.503,
    x2: 30.1255,
    y2: 30.503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDE07C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDE07C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1565_28588",
    x1: 12.2336,
    y1: 37.1233,
    x2: 37.9374,
    y2: 36.8368,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#805BEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#523AE3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirst);
export default __webpack_public_path__ + "static/media/first.750a97b759914c233aae5081c9f51511.svg";
export { ForwardRef as ReactComponent };